var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAxl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1160_205)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1160_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1622 14.4209L23.2673 8.31593L20.9511 6L16.0042 10.9469L11.0573 6L8.74132 8.31593L14.8463 14.4209C15.1661 14.7406 15.5852 14.9006 16.0042 14.9006C16.4233 14.9006 16.8424 14.7408 17.1622 14.4209ZM26 20.9428L21.0531 15.9959L26 11.0489L23.684 8.73293L17.5791 14.8379C16.9397 15.4775 16.9397 16.5143 17.5791 17.1538L23.684 23.2588L26 20.9428ZM15.9958 21.0531L20.9427 26L23.2585 23.6841L17.1537 17.5791C16.514 16.9395 15.4774 16.9395 14.8377 17.5791L8.73285 23.6841L11.0489 26L15.9958 21.0531ZM14.4209 17.1622C14.7281 16.855 14.9005 16.4386 14.9005 16.0043C14.9005 15.5699 14.7281 15.1534 14.4209 14.8463L8.31603 8.74131L6 11.0574L10.9469 16.0043L6 20.9513L8.31603 23.2672L14.4209 17.1622Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1160_205",
    x: 3.018,
    y: 3.018,
    width: 25.964,
    height: 25.964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.491
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1160_205",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1160_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxl);
export default __webpack_public_path__ + "static/media/AXL.077e900ac1a137a40e398ec8e14fda48.svg";
export { ForwardRef as ReactComponent };